/**
 * Environment variable validation and access.
 * Validates required variables at startup to fail fast.
 */

interface ValidatedEnv {
  apiBase: string;
  googleClientId: string | null;
  isDev: boolean;
  isProd: boolean;
  mode: string;
}

function validateEnv(): ValidatedEnv {
  const env = import.meta.env;

  // API_BASE is optional - defaults to /api/v1
  const apiBase = env.VITE_API_BASE ?? "/api/v1";
  const googleClientId = env.VITE_GOOGLE_CLIENT_ID || null;

  // Warn in development if API_BASE looks wrong
  if (env.DEV && !apiBase.startsWith("/") && !apiBase.startsWith("http")) {
    console.warn(
      `[env] VITE_API_BASE should start with / or http:// - got: ${apiBase}`
    );
  }

  return {
    apiBase,
    googleClientId,
    isDev: env.DEV,
    isProd: env.PROD,
    mode: env.MODE,
  };
}

export const env = validateEnv();

// Log environment in development
if (env.isDev) {
  // eslint-disable-next-line no-console
  console.log("[env] Environment validated:", {
    mode: env.mode,
    apiBase: env.apiBase,
  });
}
